import React from "react";
import Icon from "./Icon";

export default function Pagination({
  page,
  total,
  pageSize,
  onChange,
  variant = "default", // "default" | "compact"
  itemLabel = "items",
  style = {},
  className = "",
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (totalPages <= 1) return null;
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  if (variant === "compact") {
    return (
      <div className={`pagination-compact ${className}`} style={style}>
        <span>
          {start}–{end} of {total} {itemLabel}
        </span>
        <div className="pagination-compact__actions">
          <button
            type="button"
            onClick={() => onChange(page - 1)}
            disabled={page === 1}
            title="Previous Page"
          >
            <Icon
              name="chevronLeft"
              size={12}
              color={page === 1 ? "#9CA3AF" : "#334155"}
            />
          </button>
          <button
            type="button"
            onClick={() => onChange(page + 1)}
            disabled={page === totalPages}
            title="Next Page"
          >
            <Icon
              name="chevronRight"
              size={12}
              color={page === totalPages ? "#9CA3AF" : "#334155"}
            />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 20px",
        borderTop: "1px solid #F3F4F6",
        background: "#fff",
        ...style,
      }}
    >
      <span style={{ fontSize: 12, color: "#6B7280" }}>
        Showing {start}–{end} of {total}
      </span>
      <div style={{ display: "flex", gap: 4 }}>
        <button
          onClick={() => onChange(page - 1)}
          disabled={page === 1}
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "5px 8px",
            border: "1px solid #E5E7EB",
            borderRadius: 6,
            background: page === 1 ? "#F9FAFB" : "#fff",
            cursor: page === 1 ? "not-allowed" : "pointer",
            color: page === 1 ? "#9CA3AF" : "#374151",
          }}
        >
          <Icon
            name="chevronLeft"
            size={14}
            color={page === 1 ? "#9CA3AF" : "#374151"}
          />
        </button>
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
          let p;
          if (totalPages <= 5) p = i + 1;
          else if (page <= 3) p = i + 1;
          else if (page >= totalPages - 2) p = totalPages - 4 + i;
          else p = page - 2 + i;
          return (
            <button
              key={p}
              onClick={() => onChange(p)}
              style={{
                minWidth: 30,
                padding: "5px 8px",
                border: "1px solid " + (p === page ? "#1D4ED8" : "#E5E7EB"),
                borderRadius: 6,
                background: p === page ? "#1D4ED8" : "#fff",
                color: p === page ? "#fff" : "#374151",
                fontSize: 12,
                fontWeight: p === page ? 600 : 400,
                cursor: "pointer",
              }}
            >
              {p}
            </button>
          );
        })}
        <button
          onClick={() => onChange(page + 1)}
          disabled={page === totalPages}
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "5px 8px",
            border: "1px solid #E5E7EB",
            borderRadius: 6,
            background: page === totalPages ? "#F9FAFB" : "#fff",
            cursor: page === totalPages ? "not-allowed" : "pointer",
          }}
        >
          <Icon
            name="chevronRight"
            size={14}
            color={page === totalPages ? "#9CA3AF" : "#374151"}
          />
        </button>
      </div>
    </div>
  );
}
